import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="navbar w-[80%]">
      <div className="navbar-container">
        <div className="navbar-content">
          {/* Logo */}
          <div className="logo-section">
            <Link to="/" className="logo-link">
              <img src={`${process.env.PUBLIC_URL}/assets/img/sismo.svg`} alt="Logo RSC" className="logo-image" />
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="desktop-nav">
            {/* Inicio */}
            <Link to="/" className="nav-link">
              Inicio
            </Link>

            {/* Acerca de la RESNOM */}
            <div className="nav-item">
              <button className="nav-button">
                <span>Acerca de la RESNOM</span>
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>

              {/* Dropdown Menu */}
              <div className="dropdown-menu">
                <div className="dropdown-content">
                  <Link to="/acerca" className="dropdown-link">
                    <div className="dropdown-icon">
                      <svg fill="currentColor" viewBox="0 0 20 20">
                        <path
                          fillRule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </div>
                    <div className="dropdown-text">
                      <div className="dropdown-title">Conoce la RESNOM</div>
                      <div className="dropdown-description">Conoce la red a través de su historia</div>
                    </div>
                  </Link>

                  <Link to="/instrumentacion" className="dropdown-link">
                    <div className="dropdown-icon">
                      <svg fill="currentColor" viewBox="0 0 20 20">
                        <path
                          fillRule="evenodd"
                          d="M4 4a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2H4zm0 2h12v8H4V6z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </div>
                    <div className="dropdown-text">
                      <div className="dropdown-title">Instrumentación</div>
                      <div className="dropdown-description">¿Qué tipos de equipos usa la red?</div>
                    </div>
                  </Link>

                  <Link to="/procesamiento" className="dropdown-link">
                    <div className="dropdown-icon">
                      <svg fill="currentColor" viewBox="0 0 20 20">
                        <path
                          fillRule="evenodd"
                          d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </div>
                    <div className="dropdown-text">
                      <div className="dropdown-title">Procesamiento</div>
                      <div className="dropdown-description">¿Cómo se analizan y procesan los datos?</div>
                    </div>
                  </Link>

                  <Link to="/estaciones" className="dropdown-link">
                    <div className="dropdown-icon">
                      <svg fill="currentColor" viewBox="0 0 20 20">
                        <path
                          fillRule="evenodd"
                          d="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </div>
                    <div className="dropdown-text">
                      <div className="dropdown-title">Estaciones</div>
                      <div className="dropdown-description">Explora los sitios donde están las estaciones</div>
                    </div>
                  </Link>

                  <Link to="/noticias" className="dropdown-link">
                    <div className="dropdown-icon">
                      <svg fill="currentColor" viewBox="0 0 20 20">
                        <path
                          fillRule="evenodd"
                          d="M2 5a2 2 0 012-2h8a2 2 0 012 2v10a2 2 0 002 2H4a2 2 0 01-2-2V5zm3 1h2v2H5V6zm5 0H8v2h2V6zM5 9h2v2H5V9zm5 0H8v2h2V9zM5 12h2v2H5v-2zm5 0H8v2h2v-2z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </div>
                    <div className="dropdown-text">
                      <div className="dropdown-title">Noticias</div>
                      <div className="dropdown-description">Últimas noticias y eventos de la RESNOM</div>
                    </div>
                  </Link>
                </div>
              </div>
            </div>

            {/* Catálogos */}
            <div className="nav-item">
              <button className="nav-button">
                <span>Catálogos</span>
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>

              {/* Dropdown Menu */}
              <div className="dropdown-menu">
                <div className="dropdown-content">
                  <a
                    href="https://resnom.cicese.mx/earthquakes/search/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="dropdown-link"
                  >
                    <div className="dropdown-icon">
                      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                        />
                      </svg>
                    </div>
                    <div className="dropdown-text">
                      <div className="dropdown-title">Búsquedas</div>
                      <div className="dropdown-description">Busca y descarga del catálogo histórico de la RESNOM</div>
                    </div>
                  </a>

                  <Link to="/boletines" className="dropdown-link">
                    <div className="dropdown-icon">
                      <svg fill="currentColor" viewBox="0 0 20 20">
                        <path
                          fillRule="evenodd"
                          d="M4 4a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2H4zm0 2h12v8H4V6z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </div>
                    <div className="dropdown-text">
                      <div className="dropdown-title">Boletines de Sismicidad</div>
                      <div className="dropdown-description">
                        Catálogos de la actividad por mes o anual en formato PDF
                      </div>
                    </div>
                  </Link>

                  <Link to="/reportes-especiales" className="dropdown-link">
                    <div className="dropdown-icon">
                      <svg fill="currentColor" viewBox="0 0 20 20">
                        <path
                          fillRule="evenodd"
                          d="M4 4a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2H4zm0 2h12v8H4V6z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </div>
                    <div className="dropdown-text">
                      <div className="dropdown-title">Reportes Especiales de la RESNOM</div>
                      <div className="dropdown-description">Reportes de actividad sísmica en la región</div>
                    </div>
                  </Link>
                </div>
              </div>
            </div>

            {/* Divulgación */}
            <div className="nav-item">
              <button className="nav-button">
                <span>Divulgación</span>
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>

              {/* Dropdown Menu */}
              <div className="dropdown-menu">
                <div className="dropdown-content">
                  <Link to="/divulgacion" className="dropdown-link">
                    <div className="dropdown-icon">
                      <svg fill="currentColor" viewBox="0 0 20 20">
                        <path
                          fillRule="evenodd"
                          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </div>
                    <div className="dropdown-text">
                      <div className="dropdown-title">Conoce más sobre los sismos</div>
                      <div className="dropdown-description">Datos y más respuestas a preguntas de interés</div>
                    </div>
                  </Link>

                  <Link to="/preguntas" className="dropdown-link">
                    <div className="dropdown-icon">
                      <svg fill="currentColor" viewBox="0 0 20 20">
                        <path
                          fillRule="evenodd"
                          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </div>
                    <div className="dropdown-text">
                      <div className="dropdown-title">Preguntas Frecuentes</div>
                      <div className="dropdown-description">
                        Respuestas a las preguntas más frecuentes que nos hacen
                      </div>
                    </div>
                  </Link>

                  <Link to="/efectos" className="dropdown-link">
                    <div className="dropdown-icon">
                      <svg fill="currentColor" viewBox="0 0 20 20">
                        <path
                          fillRule="evenodd"
                          d="M12.395 2.553a1 1 0 00-1.45-.385c-.345.23-.614.558-.822.88-.214.33-.403.713-.57 1.116-.334.804-.614 1.768-.84 2.734a31.365 31.365 0 00-.613 3.58 2.64 2.64 0 01-.945-1.067c-.328-.68-.398-1.534-.398-2.654A1 1 0 005.05 6.05 6.981 6.981 0 003 11a7 7 0 1011.95-4.95c-.592-.591-.98-.985-1.348-1.467-.363-.476-.724-1.063-1.207-2.03zM12.12 15.12A3 3 0 017 13s.879.5 2.5.5c0-1 .5-4 1.25-4.5.5 1 .786 1.293 1.371 1.879A2.99 2.99 0 0113 13a2.99 2.99 0 01-.879 2.121z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </div>
                    <div className="dropdown-text">
                      <div className="dropdown-title">Sismos y sus efectos</div>
                      <div className="dropdown-description">Información de los fenómenos que causan los sismos</div>
                    </div>
                  </Link>
                </div>
              </div>
            </div>

            {/* Contacto */}
            <Link to="/contacto" className="nav-link">
              Contacto
            </Link>
          </div>

          {/* Logo CICESE */}
          <div className="cicese-logo">
            <a href="https://cicese.edu.mx" target="_blank" rel="noopener noreferrer">
              <img src={`${process.env.PUBLIC_URL}/assets/img/logos/cicese.svg`} alt="Logo CICESE" />
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="lg:hidden">
            <button onClick={toggleMenu} className="mobile-menu-button" aria-expanded="false">
              <span className="sr-only">Abrir menú principal</span>
              {/* Icon when menu is closed */}
              <svg className={`${isOpen ? "hidden" : "block"}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
              {/* Icon when menu is open */}
              <svg className={`${isOpen ? "block" : "hidden"}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      <div className={`mobile-menu ${isOpen ? "open" : ""}`}>
        <div className="mobile-menu-content">
          <Link to="/" className="mobile-nav-link">
            Inicio
          </Link>
          <Link to="/acerca" className="mobile-nav-link">
            Acerca de la RESNOM
          </Link>
          <Link to="/instrumentacion" className="mobile-nav-link">
            Instrumentación
          </Link>
          <Link to="/procesamiento" className="mobile-nav-link">
            Procesamiento
          </Link>
          <Link to="/estaciones" className="mobile-nav-link">
            Estaciones
          </Link>
          <Link to="/noticias" className="mobile-nav-link">
            Noticias
          </Link>
          <Link to="/boletines" className="mobile-nav-link">
            Boletines
          </Link>
          <Link to="/reportes-especiales" className="mobile-nav-link">
            Reportes Especiales
          </Link>
          <Link to="/divulgacion" className="mobile-nav-link">
            Divulgación
          </Link>
          <Link to="/preguntas" className="mobile-nav-link">
            Preguntas Frecuentes
          </Link>
          <Link to="/efectos" className="mobile-nav-link">
            Efectos
          </Link>
          <Link to="/contacto" className="mobile-nav-link">
            Contacto
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
